import { call, select } from 'redux-saga/effects'
import { getAccessToken, getUserLocale } from './auth/selectors'
import { loadLocale } from './locale'

const urlBase = process.env.REACT_APP_URL_BASE || window.REACT_APP_URL_BASE

function* makeCommonHeaders(extraHeaders = {}) {
  const token = yield select(getAccessToken)
  const userLocale = (yield select(getUserLocale)) || (yield select(loadLocale))

  const tokenHeader = token ? { Authorization: `Bearer ${token}` } : {}
  const localeHeader = { 'Content-Language': userLocale }

  return {
    Accept: 'application/json',
    ...tokenHeader,
    ...localeHeader,
    ...extraHeaders,
  }
}

const makeBody = data => (data != null ? JSON.stringify(data) : undefined)

const readUrl = (url = '') => new URL(`${urlBase}/${url}`).href

function* checkResponse(response) {
  if (!response.ok) {
    throw response
  }

  if (response.status !== 204) {
    return yield call([response, 'json'])
  }
}

export function* get(url = '', headers = {}) {
  const res = yield call(fetch, readUrl(url), {
    method: 'GET',
    headers: yield call(makeCommonHeaders, headers),
  })
  return yield call(checkResponse, res)
}

export function* post(url, data, headers = {}) {
  const res = yield call(fetch, readUrl(url), {
    method: 'POST',
    headers: yield call(makeCommonHeaders, headers),
    body: makeBody(data),
  })
  return yield call(checkResponse, res)
}

export function* del(url, data, headers = {}) {
  const res = yield call(fetch, readUrl(url), {
    method: 'DELETE',
    headers: yield call(makeCommonHeaders, headers),
    body: makeBody(data),
  })
  return yield call(checkResponse, res)
}
export function* put(url, data, headers = {}) {
  const res = yield call(fetch, readUrl(url), {
    method: 'PUT',
    headers: yield call(makeCommonHeaders, headers),
    body: makeBody(data),
  })
  return yield call(checkResponse, res)
}
